import {Injectable, EventEmitter} from '@angular/core';

// Classes
import {ProductCategory} from '../classes/product-category';
import {Product} from '../classes/product';

let debug, debugOff = function (...any) { };
process.env.NODE_ENV !== 'production' && (debug = require('debug')('app:CartService'));

@Injectable()
export class CartService {

    public cartProducts: Array<Product> = [];
    private _catalogService;
    private _productsService;
    private _applyVspaProdAddLogic;
    private _applyVspaProdRemoveLogic;
    public productEvent = new EventEmitter();

    // Used to cache the next product that will replace the current one.
    // Applies for categories that do no allow multiple products in cart.
    public replacementProduct: Product = null;

    public state = {
        totalPrice: 0,
        isEmpty: true,
    };

    // TODO: Temporary, remove all events, use state store
    public events = {
        cartUpdated: new EventEmitter(),
        // productAddedToCart: new EventEmitter(),
        // productRemovedFromCart: new EventEmitter(),
        // cartIsEmpty: new EventEmitter()
    };

    
    constructor () {
        // 'Construct cart service' );
    }

    
    public init (catalogService, applyVspaProdAddLogic, applyVspaProdRemoveLogic) {
        // 'Initialise dynamic properties service' );
        this._catalogService = catalogService;
        this._productsService = catalogService._productsService;
        this._applyVspaProdAddLogic = applyVspaProdAddLogic.bind( catalogService );
        this._applyVspaProdRemoveLogic = applyVspaProdRemoveLogic.bind( catalogService );
    }

    
    private _addProduct (product: Product, categoryId: string ) {
        // 'Add "' + product.code + '" product in cart' );

        // Products can be in multiple categories, so we need to register category from which the product was added to cart.
        product.taxonomy.currentCategoryId = categoryId;
        debugOff( 'Taxonomy current category id:', categoryId );
        
        this.state.isEmpty === false && (this.state.isEmpty = true);

        // Get product category
        let prodCateg: ProductCategory = product.getCurrentCategory();
        debugOff( 'Product category:', prodCateg );

        // Check if multiple products from same category are NOT allowed
        if (prodCateg.allowInCartMultipleProds === false) {
            this.replacementProduct = product;
            this.removeProductsByCategory( prodCateg );
            this.replacementProduct = null;
        }

        // TODO: Decouple, Should be in app
        // If product is generator, update globals
        if ( product.taxonomy.currentCategoryId === 'generators' ) {
            this._catalogService._globals.selectedGenerator = product.code;
            this._productsService.refreshAllProducts();
            // 'Selected generator:', [product] );
        }

        // TODO: Decouple, Should be in app
        // If product is towel warmer, update globals
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-300' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-500'
        ) {
            this._catalogService._globals.selectedTowelWarmer = product.code;
            this._productsService.refreshAllProducts();
            // 'Selected towel warmer:', [product] );
        }

        // Update package and dynamic properties
        product.refreshState();

        // TODO: Decouple
        this._applyVspaProdAddLogic( product );

        // Add new product in cart
        this.cartProducts.push( product );

        // Check for incompatible products
        // this._hideProdsIncompatibleWithCart();
        // this._removeIncompatibleProdsFromCart( product );
        // product.checkIsDisplayed();

        product.isAddedToCart = true;

        // Sort cart to show products in proper order
        this._updateProductsSortOrder();

        this.updateTotalPrice();
        this.events.cartUpdated.emit( null );
        // this.events.productAddedToCart.emit({ product: product });
    }

    
    public removeProduct (product: Product) {
        // 'Remove "' + product.code + '" product from cart' );
        var index = this.cartProducts.indexOf( product );

        // Remove product
        index >= 0 && this.cartProducts.splice( index, 1 );

        // Set cart as empty if no products are selected
        if (this.cartProducts.length === 0 &&
            this.state.isEmpty === true
        ) {
            this.state.isEmpty = false;
            // this.events.cartIsEmpty.emit(null);
        }

        product.isAddedToCart = false;

        // TODO: Decouple, Should be in app
        // If product is generator, update globals
        if (product.taxonomy.currentCategoryId === 'generators') {
            this._catalogService._globals.selectedGenerator = null;
            this._productsService.refreshAllProducts();
            // 'Removed generator:', [product] );
        }

        // TODO: Decouple, Should be in app
        // If product is towel warmer, update globals
        if (product.taxonomy.currentCategoryId === 'towel-warmers-200' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-300' ||
            product.taxonomy.currentCategoryId === 'towel-warmers-500'
        ) {
            this._catalogService._globals.selectedTowelWarmer = null;
            this._productsService.refreshAllProducts();
            // 'Removed towel warmer:', [product] );
        }

        // Check for incompatible products
        // this._hideProdsIncompatibleWithCart();
        // product.checkIsDisplayed();

        // TODO: Decouple
        this._applyVspaProdRemoveLogic( product );

        this.updateTotalPrice();
        this.events.cartUpdated.emit( null );
        // this.events.productRemovedFromCart.emit({ product: product });
    }

    
    private _checkProductIsInCart (product: Product) {
        //'Check if "' + product.code + '" product is in cart');
        return this.cartProducts.indexOf( product ) !== -1;
    }

    
    public emptyCart() {
        // 'Empty cart' );
        var tempCartProdsList: Array<Product> = [];

        // Prevents the effects of shifting the products array while looping it at the same time
        this.cartProducts.forEach(
            cartProduct => tempCartProdsList.push(cartProduct)
        );

        tempCartProdsList.forEach(
            cartProduct => cartProduct.removeFromCart()
        );

        console.log('Empty cart - Cart produts', this.cartProducts)
    }

    
    public updateTotalPrice () {
        // 'Get cart total price' );
        this.state.totalPrice = 0;
        this.cartProducts.forEach((product) => {
            this.state.totalPrice += product.getPrice();
        });
    }

    
    public getCartProducts () {
        debugOff( 'Get cart products' );
        return this.cartProducts;
    }

    
    public getCartProductsByCategory (category: ProductCategory) {
        debugOff( 'Get cart products by "' + category.id + '"' );

        // Filter products by category id
        return this.cartProducts.filter( (product: Product) => {
            return product.taxonomy.categories.indexOf( category.id ) !== -1;
        } );
    }

    
    public removeProductsByCategory (category: ProductCategory) {     // Get products from same category
        debugOff( 'Remove products from cart by "' + category.id + '" category' );

        let products = this.getCartProductsByCategory( category );
        debugOff( 'Cart category products:', products );

        // Remove products
        products.forEach( (product: Product) => {
            // 'Remove "' + product.code + '"', [product] );
            product.removeFromCart();
        });
    }

    // TODO: reenable method
    // // Hide catalog products if incompatible with cart
    // // <WARNING> Don't change unless you uderstand this code!
    // private _hideProdsIncompatibleWithCart() {
    //
    //     var catalogProducts = this._productsService.data.products,
    //         cartProducts = this.cartProducts;
    //
    //     // Unhide all products
    //     catalogProducts.forEach(catalogProduct => catalogProduct.unhide());
    //
    //     // Preserve all prods unhidden if no generator is selected
    //     if (this.generatorCfg.generatorIsSelected === false) { return; }
    //
    //     // REQUIRE - Hide catalog products that require products not available in cart.
    //     catalogProducts.forEach(catalogProduct => {
    //
    //         // Ignore static products
    //         if (catalogProduct.IsRequiringOtherProds === false) { return; }
    //
    //         // Hide all that require another product
    //         catalogProduct.hide();
    //
    //         // Unhide products that have a required product in cart
    //         catalogProduct.IsRequiring.forEach(requiredProduct => {
    //             requiredProduct.Selected === true && catalogProduct.unhide();
    //         });
    //
    //     });
    //
    //     // EXCLUDE - Hide catalog products that are exluded by products from cart.
    //     catalogProducts.forEach(catalogProduct => {
    //
    //         // Ignore static products
    //         if (catalogProduct.IsExcludedByOtherProds === false) { return; }
    //
    //         // Unhide products that have a required product in cart
    //         catalogProduct.IsExcludedBy.forEach(excludingProduct => {
    //             excludingProduct.Selected === true && catalogProduct.hide();
    //         });
    //
    //     });
    //
    // }

    // TODO: reenable method
    // // Remove cart products if incompatible with last added product
    // // <WARNING> Don't change unless you understand this code!
    // private _removeIncompatibleProdsFromCart(newProduct) {
    //
    //     var catalogProducts = this._productsService.data.products,
    //         cartProducts = this.cartProducts;
    //
    //     // REQUIRE - Remove products from cart that do not have any required products in cart
    //     var productsToRemove = [];
    //
    //     cartProducts.forEach( cartProduct => {
    //
    //         // Ignore static products
    //         // Preserve all prods in cart if no generator is selected
    //         if (cartProduct.IsRequiringOtherProds === false ||
    //             this.generatorCfg.generatorIsSelected === false
    //         ) { return; }
    //
    //         var keepInCart = false;
    //
    //         cartProduct.IsRequiring.forEach( requiredProduct => {
    //             requiredProduct.Selected === true && (keepInCart = true);
    //         });
    //
    //         keepInCart === false && productsToRemove.push(cartProduct);
    //
    //     });
    //
    //     productsToRemove.forEach( cartProduct => cartProduct.remove() );
    //
    //     // EXCLUDE - Remove products from cart that are excluded by newly added product
    //     newProduct.IsExcludingOtherProds === true && cartProducts.forEach(
    //         cartProduct => cartProduct.CheckIfIsExcludedBy(newProduct) === true && cartProduct.remove()
    //     );
    //
    // }

    
    private _updateProductsSortOrder() {
        // 'Sort all products in cart' );
        let self = this;

        // Sort products
        this.cartProducts.sort( (a: Product, b: Product) => {
            let prodACat = a.getCurrentCategory();
            let prodBCat = b.getCurrentCategory();

            let sortValue;

            // Check if parent categories have the same sort order
            if ( prodACat.sortOrder === prodBCat.sortOrder ) {

                // Sort by product order
                sortValue = a.taxonomy.sortOrder[prodACat.id] - b.taxonomy.sortOrder[prodBCat.id];
            } else {

                // Sort by category order
                sortValue = prodACat.sortOrder - prodBCat.sortOrder;
            }

            return sortValue;
        });

        // 'Sorted cart products:', this.cartProducts );
    }


    
    public appendProductAPI (products: Array<Product>) {
        // 'Append product API' );

        products.forEach( product => {

            
            product.toggleInCart = ( categoryId: string ) => {
                debugOff( 'Toggle add/remove "' + product.code + '" product in cart' );
                let isInCart = product.isAddedToCart;

                if (isInCart === true) {
                    product.removeFromCart();
                } else {
                    product.addToCart( categoryId );
                }
            };

            
            product.addToCart = ( categoryId ) => {
                debugOff( 'Add "' + product.code + '" product in cart' );
                this._addProduct( product, categoryId );
            };

            
            product.removeFromCart = () => {
                debugOff( 'Remove "' + product.code + '" product from cart' );
                this.removeProduct( product );
            };

            
            // TODO: Compute total price
            product.getPrice = () => {
                debugOff( 'Get "' + product.code + '" product price' );
                return product.price || 0;
            };
        });
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/catalog/shared/services/cart-service.ts